import { render, staticRenderFns } from "./produit_vignette.vue?vue&type=template&id=1d9a07c0&scoped=true&"
import script from "./produit_vignette.vue?vue&type=script&lang=js&"
export * from "./produit_vignette.vue?vue&type=script&lang=js&"
import style0 from "./produit_vignette.vue?vue&type=style&index=0&id=1d9a07c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9a07c0",
  null
  
)

export default component.exports